import React from "react";
import {connect} from 'react-redux';
import styles from "../login_page.module.scss";
import {Alert} from "react-bootstrap";
import {dismiss_success} from "../../_redux/_actions/authentication.actions";

const SuccessMessage = (props) => {
  const {successMessage, dismissSuccess} = props;
  return ( successMessage ?
    <Alert onClose={dismissSuccess} variant="success" className={styles.alertMessage} dismissible>
      <Alert.Heading>Success!</Alert.Heading>
      <p>
        {successMessage}
      </p>
    </Alert> : <></>
  );
}

function mapStateToProps(state) {
  const { successMessage} = state.authentication;
  return { successMessage };
}

const mapDispatchToProps = dispatch => ({
  dismissSuccess: () => dispatch(dismiss_success())
});

export default connect(mapStateToProps, mapDispatchToProps)(SuccessMessage)